import { RotateCw, Smartphone } from "lucide-react";

import { useI18nStore } from "../../stores/i18nStore";
import {
  OrientationMode,
  useOrientationStore,
} from "../../stores/orientationStore";

const OPTIONS: { mode: OrientationMode; icon: typeof RotateCw }[] = [
  { mode: "portrait", icon: Smartphone },
  { mode: "system", icon: RotateCw },
];

export function OrientationSettingsCard() {
  const { t } = useI18nStore();
  const { mode, setMode } = useOrientationStore();

  const label: Record<OrientationMode, string> = {
    portrait: t.orientationPortrait,
    system: t.orientationSystem,
  };

  return (
    <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
      <h2 className="text-xl font-bold text-gray-900 mb-6 flex items-center space-x-2">
        <RotateCw className="w-5 h-5 text-teal-600" />
        <span>{t.orientationTitle}</span>
      </h2>

      <div className="grid grid-cols-2 gap-3" role="radiogroup">
        {OPTIONS.map(({ mode: option, icon: Icon }) => (
          <button
            key={option}
            role="radio"
            aria-checked={mode === option}
            onClick={() => setMode(option)}
            data-testid={`orientation-option-${option}`}
            className={`flex flex-col items-center gap-2 rounded-xl border-2 p-4 transition ${
              mode === option
                ? "border-blue-600 bg-blue-50 text-blue-800"
                : "border-gray-200 text-gray-700 hover:border-gray-300"
            }`}
          >
            <Icon className="w-5 h-5" aria-hidden="true" />
            <span className="text-sm font-medium">{label[option]}</span>
          </button>
        ))}
      </div>

      <p className="mt-4 text-sm text-gray-600">{t.orientationHint}</p>
    </div>
  );
}
